import * as angular from 'angular';

import { ApiModule, QAdapterModule } from '@mode/legacy/data-access-model-js';
import { ClientDataService } from '../services/client-data-service';
import ColumnOptionsService from '../services/column-options-service';
import DatasetService from '../services/dataset-service';
import EditorService from '../services/editor-service';
import { FeatureToggleService } from '../services/feature-toggle-service';
import FormatOptionsService from '../services/format-options-service';
import { QueryDataService } from '../services/query-data-service';
import { ReportApiService } from '../services/report-api-service';
import { ReportDataService } from '../services/report-data-service';
import { ReportDatasetService } from '../services/report-dataset-service';
import ReportLinkService from '../services/report-link-service';
import TableDataService from '../services/table-data-service';
import TimingService from '../services/timing-service';
import { WindowMessageService } from '../services/window-message-service';

import { downgradeInjectable } from '@angular/upgrade/static';

//  Collections And Spaces

import { flushEffectQueue } from '@mode/legacy/util-domain';

import { LegacyAppStateStoreService } from '@mode/legacy/util-domain';
import { storeServiceConnector } from '~/services/store-service';

import { GithubDomainAngularJsModule } from '@mode/github/domain-angularjs';
import { NgxCookieService } from '@mode/shared/data-access-webapp';
import { ReportDetailsScheduleFacade } from '~/components/schedules/report-details-schedule.facade';
import { DowngradedWorkspaceSettingsDomainModule } from '~/modules/downgraded-angular/workspace-settings/domain.module';
import { DowngradedDefinitionsDomainModule } from './definitions/domain';
import { DowngradedAccountsDomainModule } from './downgraded-angular/accounts/domain.module';
import { DowngradedAccountsFeatureHeaderModule } from './downgraded-angular/accounts/feature-header.module';
import { DowngradedAngularCoreModule } from './downgraded-angular/angular/core.module';
import { DowngradedCollectionsDomainModule } from './downgraded-angular/collections/domain.module';
import { DowngradedDatasetDomainModule } from './downgraded-angular/dataset/domain.module';
import { DowngradedHomeUIModule } from './downgraded-angular/home/ui.module';
import { DowngradedMetricsDomainModule } from './downgraded-angular/metrics/domain.module';
import { DowngradedNgrxEffectsModule } from './downgraded-angular/ngrx/effects.module';
import { DowngradedNotebooksDomainModule } from './downgraded-angular/notebooks/domain.module';
import { DowngradedSchemasDomainModule } from './downgraded-angular/queries/schemas/domain.module';
import { DowngradedReportEditorDomainModule } from './downgraded-angular/report-editor/domain.module';
import { DowngradedReportViewerDomainModule } from './downgraded-angular/report-viewer/domain.module';
import { DowngradedReportViewerPdfExportApiModule } from './downgraded-angular/report-viewer/pdf-export/api.module';
import { DowngradedReportsDomainModule } from './downgraded-angular/reports/domain.module';
import { DowngradedReportsUIModule } from './downgraded-angular/reports/ui.module';
import { DowngradedSessionsDomainModule } from './downgraded-angular/sessions/domain.module';
import { DowngradedSharedAuthorizationModule } from './downgraded-angular/shared/authorization.module';
import { DowngradedSharedDataAccessAlgoliaModule } from './downgraded-angular/shared/data-access-algolia.module';
import { DowngradedSharedDataAccessFlamingoModule } from './downgraded-angular/shared/data-access-flamingo.module';
import { DowngradedSharedDataAccessWebappModule } from './downgraded-angular/shared/data-access-webapp.module';
import { DowngradedSharedUIModule } from './downgraded-angular/shared/ui.module';
import { DowngradedSharedUtilErrorHandlingModule } from './downgraded-angular/shared/util-error-handling.module';
import { DowngradedSharedUtilFeatureFlagsModule } from './downgraded-angular/shared/util-feature-flags.module';
import { DowngradedSharedUtilJsModule } from './downgraded-angular/shared/util-js.module';
import { DowngradedSharedUtilSegmentModule } from './downgraded-angular/shared/util-segment.module';
import { DowngradedSwitchViewsDomainModule } from './downgraded-angular/switch-views/domain.module';

const elem = 'meta[name=flamingo-host]';
const host = angular.element(elem).attr('content');

/**
 * @deprecated No new services should be added. Please add to specific app modules.
 */
export const SharedServicesModule = angular
  .module('mode.shared.services', [
    'ngCookies',
    ApiModule,
    QAdapterModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAccountsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAccountsFeatureHeaderModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedAngularCoreModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedAuthorizationModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedCollectionsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedDatasetDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedHomeUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedDefinitionsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedMetricsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedNotebooksDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedNgrxEffectsModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportEditorDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportsUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportViewerDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedReportViewerPdfExportApiModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSchemasDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSessionsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedDataAccessAlgoliaModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedDataAccessFlamingoModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedDataAccessWebappModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUtilErrorHandlingModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUtilFeatureFlagsModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUtilJsModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUtilSegmentModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSharedUIModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedSwitchViewsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    DowngradedWorkspaceSettingsDomainModule,
    /**
     * STOP! (hammer time)
     *
     * Please don't add anything here. Add module requirements directly to the modules that need them! These will load on every page, even if they aren't used.
     *
     */
    GithubDomainAngularJsModule,
  ])
  .service('DatasetService', downgradeInjectable(DatasetService))
  .service('TableDataService', TableDataService)
  .service('ReportDatasetService', downgradeInjectable(ReportDatasetService))
  .service('QueryDataService', QueryDataService)
  .service('ColumnOptionsService', ColumnOptionsService)
  .service('FormatOptionsService', FormatOptionsService)
  .service('ReportLinkService', ReportLinkService)
  .service('CookieService', downgradeInjectable(NgxCookieService))
  .service('ClientDataService', ClientDataService)
  .service('TimingService', downgradeInjectable(TimingService))
  .service('EditorService', EditorService)
  .service('FeatureToggleService', FeatureToggleService)
  .service('WindowMessageService', WindowMessageService)
  .service('ReportDataService', ReportDataService)
  .service('ReportDetailsScheduleFacade', ReportDetailsScheduleFacade)
  .service('ReportApiService', ReportApiService).name;

angular
  .module('mode.shared.services')
  .constant('flamingoHost', host)
  .service('RxStoreService', downgradeInjectable(LegacyAppStateStoreService))
  .run([
    'ChartEffects',
    'FlamingoGfEffects',
    'ScheduleModalEffects',
    'HomeEffects',
    'RxStoreService',
    function (ce, fge, sme, hme, store: LegacyAppStateStoreService) {
      flushEffectQueue((action) => store.dispatch(action));
    },
  ]); // Init legacy effects

angular.module('mode.shared.services').service('StoreService', function () {
  return storeServiceConnector;
});
